import { render, staticRenderFns } from "./TabTeacher.vue?vue&type=template&id=5e2449b3"
import script from "../../../services/teacher/DetailCourseTab/tab-teacher.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/DetailCourseTab/tab-teacher.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports